import { inject } from '@angular/core';
import {
  CanActivateChildFn,
  CanActivateFn,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';

export const authGuard: CanActivateFn = route => {
  return getProfile(route);
};

export const authGuardChild: CanActivateChildFn = (
  route: ActivatedRouteSnapshot
) => {
  return getProfile(route);
};

async function getProfile(route: ActivatedRouteSnapshot) {
  const _router = inject(Router);
  const local_Service = inject(LocalStorageService);
  const token = local_Service.getItem('invoiceToken');

  if (!token) {
    _router.navigateByUrl('/auth');
    return false;
  }

  return true;
}
